import classNames from "classnames";
import {CatalogFilter, Filter, SelectedFilter} from "@/features/catalog-filters";
import {CatalogSelectedFilters} from "@/features/catalog-selected-filters";
import {CatalogSort, CatalogSortDto} from "@/features/catalog-sort";
import {useCatalogFiltersDrawer} from "@/widgets/catalog-filters-drawer";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import styles from "./CatalogFilters.module.scss";

type Props = {
    filters: Filter[];
    dataSort: CatalogSortDto[];
    insertColors: Record<string, string>;
    isDesktop?: boolean;
    // headerHeight: number;
    className?: string;
    selectedFilters: SelectedFilter[];
};

export const CatalogFilters = (
    {
        filters,
        dataSort,
        insertColors,
        isDesktop = false,
        className,
        selectedFilters,
    }: Props
) => {
    // const scrollDirection = useScrollDirection();
    //
    // const headerHeight = useAllStore((state) => state.headerHeight);

    const openModal = useCatalogFiltersDrawer(s => s.actions.openModal);

    // const top = scrollDirection === "down" ? '0px' : headerHeight + 'px';

    return (
        <div className={classNames(styles.container, className)}>
            <div className={styles.filters}>
                    <Button
                        variant={`tertiary`}
                        size={isDesktop ? `l` : `m`}
                        className={styles.allFiltersButton}
                        onClick={openModal}
                    >
                        <Svg id={`allFiltersIcon`} className={styles.allFiltersIcon} />
                        <span className={styles.allFiltersName}>Все фильтры</span>
                    </Button>
                <div className={styles.list}>
                    {filters.map((filter) => {
                        return (
                            <CatalogFilter
                                key={filter.key}
                                filter={filter}
                                isDesktop={isDesktop}
                                insertColors={insertColors}
                            />
                        )
                    })}
                </div>
                <div className={styles.sortButton}><CatalogSort dataSort={dataSort} isDesktop={isDesktop} /></div>
                <CatalogSelectedFilters
                    className={styles.chips}
                    size={isDesktop ? `l` : `m`}
                    selectedFilters={selectedFilters}
                />
            </div>
        </div>
    );
}
